import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      await axios.post(`${BACKEND_URL}/api/newsletter`, { email });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative py-20 bg-[#080714] overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-48 bg-purple-600/12 rounded-full blur-[100px] pointer-events-none"/>
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-purple-500/15 border border-purple-500/25 mb-5">
          <Mail size={20} className="text-purple-400"/>
        </div>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white tracking-tight mb-3">
          Be among the first.
        </h2>
        <p className="text-white/55 text-base leading-relaxed mb-8 max-w-xl mx-auto">
          ROMIND KIDS is preparing for launch. Join our early access list to be notified when the platform becomes available.
        </p>

        {status === 'success' ? (
          <div data-testid="newsletter-success" className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-emerald-500/10 border border-emerald-500/25 text-emerald-400 text-sm font-medium">
            <div className="w-5 h-5 rounded-full bg-emerald-500/20 border border-emerald-500/30 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-emerald-400"/>
            </div>
            You're on the list — we'll be in touch.
          </div>
        ) : (
          <form data-testid="newsletter-form" onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="flex-1 bg-white/5 border border-white/12 rounded-full px-5 py-3 text-white text-sm placeholder-white/25 focus:outline-none focus:border-purple-500/50 focus:bg-white/8 transition-all"
            />
            <button
              data-testid="newsletter-submit-btn"
              type="submit"
              disabled={status === 'loading'}
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-sm bg-purple-600/85 border border-purple-400/40 text-white hover:bg-purple-500 transition-all disabled:opacity-50 flex-shrink-0"
            >
              {status === 'loading' ? 'Submitting...' : <><span>Get Early Access</span> <ArrowRight size={14}/></>}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p data-testid="newsletter-error" className="text-red-400 text-xs mt-3">
            Something went wrong. Try emailing us at contact@romindkids.tech
          </p>
        )}

        <p className="text-white/25 text-xs mt-4">No spam. Just the launch announcement when we're ready.</p>
      </div>
    </section>
  );
};

export default NewsletterSection;
